module.exports = __webpack_public_path__ + "static/media/dragon.daa48a25.jpg";